/* ASM STORE — Productos vistos recientemente
   Guarda hasta 8 productos en localStorage y renderiza las tarjetas
   DOM construction uses safe methods (no innerHTML with user data) */
(function () {
  var STORAGE_KEY = 'asm_recently_viewed';
  var MAX_ITEMS   = 8;

  function getMeta(selector) {
    var el = document.querySelector(selector);
    return el ? el.content || el.href || '' : '';
  }

  /* ── Guardar producto actual ───────────────────────────── */
  var productId = getMeta('meta[name="product-id"]');
  if (productId) {
    var productHandle = getMeta('meta[name="product-handle"]');
    var productTitle  = getMeta('meta[property="og:title"]') || document.title;
    var productImage  = getMeta('meta[property="og:image"]');
    var productUrl    = getMeta('link[rel="canonical"]') || window.location.pathname;

    if (productHandle) {
      var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      items = items.filter(function (i) { return i.id !== productId; });
      items.unshift({ id: productId, handle: productHandle, title: productTitle, image: productImage, url: productUrl });
      if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }
  }

  /* ── Renderizar sección ────────────────────────────────── */
  var section = document.querySelector('.recently-viewed-section');
  if (!section) return;

  var currentId = section.dataset.currentProduct || '';
  var limit     = parseInt(section.dataset.limit || '4', 10);
  var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
              .filter(function (i) { return i.id !== currentId; })
              .slice(0, limit);

  if (!items.length) { section.hidden = true; return; }

  var grid = section.querySelector('.recently-viewed__grid');
  if (!grid) return;

  items.forEach(function (item) {
    var card  = document.createElement('a');
    card.href = item.url;
    card.className = 'recently-viewed__card';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'recently-viewed__img-wrap';

    if (item.image) {
      var img   = document.createElement('img');
      img.src   = item.image;
      img.alt   = item.title;
      img.loading  = 'lazy';
      img.width = 300;
      img.height   = 300;
      imgWrap.appendChild(img);
    } else {
      var placeholder = document.createElement('div');
      placeholder.className = 'recently-viewed__img-placeholder';
      imgWrap.appendChild(placeholder);
    }

    var info  = document.createElement('div');
    info.className = 'recently-viewed__info';
    var title = document.createElement('p');
    title.className = 'recently-viewed__title';
    title.textContent = item.title;
    info.appendChild(title);

    card.appendChild(imgWrap);
    card.appendChild(info);
    grid.appendChild(card);
  });

  section.hidden = false;
})();
